export default __webpack_public_path__ + "static/media/main.8cec9ca5.gif";